import React, {useEffect, useState } from "react";
import Button from "../../components/common/Button";
import Input from "../../components/common/Input";
import Radio from "../../components/common/Radio";
import Jumpbotron from "../../components/common/Jumpbotron";
import Select from "../../components/common/Select";
import Modal from "../../components/common/Modal";
import DatosProveedor from "../../components/common/DatosProveedor";
import Tab from "../../components/common/Tab";
import { useDispatch } from "react-redux";
import { initDataProveedorTransparencia_Ex,initDataProveedorTransparencia_Val,
        initDataProveedorTransparenciaPreguntast_Val,initDataProveedorTransparencialistaCuadro_Val} from "../../utils/options";
import CustomTable from "../../components/CustomTable";
import TableRimac from "../../components/common/Table/TableRimac";
import { hideLoading, showLoading } from "../../redux/actions/general";
import { headDataUsers } from "../../components/CustomTable/headData";
import usersData from "../../components/CustomTable/usersData";
import addUserIcon from "../../assets/icon_add_user.svg";
import deleteLogo from "../../assets/gl_delete-20.svg";
import chevrotIconUp from "../../assets/gl_arrow_up.svg";
import chevrotIconDown from "../../assets/gl_arrow_down.svg";
import "./styles.scss";
//import { Checkbox } from "aws-amplify-react";
import { callService } from "../../amplify/callService";
import { CONSTANTES } from "../../utils/Constantes";
import Alert from "../../components/common/Alert";
import { getColorByStatusFlag } from "../../utils/utils";
import { iconEdit, iconCheck } from "../../components/common/icons";
import Chip from "../../components/common/Chip";
import Pagination from "../../components/common/Pagination";
import InputWithDropdown from "../../components/common/InputWithDropdown";
import Checkbox from "../../components/common/Checkbox";
import Validate from "../../utils/Validate";
const ProveedoresTransparencia = ({dataT, keyIndex, handleActualizarFicha, handleChangePaso, indEmpresa}) => {
  const dispatch = useDispatch();

  const [openAdd, setOpenAdd] = useState(false);
  const [tagBody, setTagBody] = useState("nostate");  
  const [showAlert, setShowAlert] = useState({
    show: false,
    title: "",
    message: "",
    type: "",
  });
  const [currentPage, setCurrentPage] = useState();
  const [paginationData, setPaginationData] = useState({
    totalPages: 5,
  });
  const [arrPerfiles, setArrPerfiles] = useState([]);
  const [arrPais, setArrPais] = useState([]);
  const [arrDepartamento, setarrDepartamento] = useState([]);
  const [arrProvincia, setArrProvincia] = useState([]);
  const [arrDistrito, setArrDistrito] = useState([]);
  const [arrTipoDoc, setArrTipoDoc] = useState([]);
  const [arrMoneda , setArrMoneda] = useState([]);
  const [arrTipoEstado, setArrTipoEstado] = useState([]);
  const [arrTipoTercero, setArrTipoTercero] = useState([]);
  const [dataTemp, setDataTemp] = useState(null);
  const [infoModal, setInfoModal] = useState(null);
  const [tableData, setTableData] = useState(null);
  const [indVmTra, setIndVmTra] = useState(false);
  const [arrPreguntat, setArrPreguntat] = useState([]); 
  const [data, setData] = useState(Validate.extraerAtributos(initDataProveedorTransparencia_Ex, dataT));
  const [validacion, setValidacion] = useState({preguntast:[],listaCuadro:[] });
  useEffect(() => {    
    setData(Validate.extraerAtributos(initDataProveedorTransparencia_Ex, dataT));
    getPreguntast();
  }, [dataT]);
  useEffect(() => {    
    getMonedas();
    getTipoDoc();
    getEstadosPersona();
    getPreguntast();
    getTipoTercero();
    data.listaCuadro = [];
    setTableData(data.listaCuadro);
  }, []);
  useEffect(() => {
    if(arrPreguntat.length>0){
      let preguntast = arrPreguntat.map(obj=>{ let jsData = data.preguntast.find(el=>el.idpPregunta==obj.value);
                                          return {idpPregunta: obj.value, idpTipoPregunta: 'PREGUNTAT', ...jsData}
                                        });                                        
      data.preguntast = preguntast;
      handleChange("preguntast", preguntast,0);
      let listaCuadro = dataT.accionista.concat(dataT.representante).concat(dataT.grupoEconomico);
      listaCuadro.push({nombres: dataT.nombreRazonSocial, idpEstado: dataT.idpEstadoInvestigacion, aniosSentencia: dataT.aniosSentencia, idpTipoTercero: "PRV"});
      data.listaCuadro = listaCuadro;
      handleChange("listaCuadro", listaCuadro,0);
      setTableData(data.listaCuadro);
    } 
  }, [arrPreguntat]);
  let arrSN=[{value:'S',text:'SI'},{value:'N',text:'NO'}];
  const getMonedas = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarParametrosTipo.replace('{tipoParametro}','MONEDA'));
      if (response.ok && response.data && response.data.payload) {
        let monedas = response.data.payload.map((el, index) => {
          return {
            value: el.codparametro,
            text: el.descparametro
          };
        });
        setArrMoneda(monedas);
      }
    } catch (ex) {
      console.log("Error al obtener getMonedas", ex);
    }
  };
  const getEstadosPersona = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarParametrosTipo.replace('{tipoParametro}','TIPESTADOPER'));
      if (response.ok && response.data && response.data.payload) {
        let estados = response.data.payload.map((el, index) => {
          return {
            value: el.codparametro,
            text: el.descparametro
          };
        });
        setArrTipoEstado(estados);
      }
    } catch (ex) {
      console.log("Error al obtener estados", ex);
    }
  };
  const getTipoTercero = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarParametrosTipo.replace('{tipoParametro}','TIPO_TERCERO'));
      if (response.ok && response.data && response.data.payload) {
        let tipo = response.data.payload.map((el, index) => {
          return {
            value: el.codparametro,
            text: el.descparametro
          };
        });
        setArrTipoTercero(tipo);
      }
    } catch (ex) {
      console.log("Error al obtener estados", ex);
    }
  };
  const getTipoDoc = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarParametrosTipo.replace('{tipoParametro}','TIPDOC'));
      if (response.ok && response.data && response.data.payload) {
        let tipdoc = response.data.payload.map((el, index) => {
          return {
            value: el.codparametro,
            text: el.descparametro
          };
        });
        setArrTipoDoc(tipdoc);
      }
    } catch (ex) {
      console.log("Error al obtener tipdoc", ex);
    }
  };
  const getPreguntast = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarParametrosTipo.replace('{tipoParametro}','PREGUNTAT'));
      if (response.ok && response.data && response.data.payload) {
        let preguntast = response.data.payload.map((el, index) => {
          return {
            value: el.codparametro,
            text: el.descparametro
          };
        });
        preguntast = preguntast.sort((a,b)=>Number(a.value)-Number(b.value));
        setArrPreguntat(preguntast);
      }
    } catch (ex) {
      console.log("Error al obtener preguntas", ex);
    }
  };
  const handleChange = (name, value, i) => {
    let jsonAd = {};    
    value = value.toUpperCase ? value.toUpperCase() : value;
    setData({ ...data, [name]: value });
    try{
    if(value instanceof Array){
      //let limpArr = Validate.limpiarArregloIdProveedor(value.map((obj) => Object.assign({},obj)));
      validacion[name][i]=false;
      setValidacion({ ...validacion, [name]: validacion[name]});
    }else{
      setValidacion({ ...validacion, [name]: false });
    }
  }catch(err){
    console.log("Name:",name);
    console.log("value:",value);
    console.log("ERROR",err);
  }
    
  };
  const validarFormulario = () => {
    let resp = true;
    for (var name in Object.assign({},initDataProveedorTransparencia_Val,Validate.limpiarObjeto(data))) {
      //if (data.hasOwnProperty(name)){
        if(!data[name] ){
          validacion[name] = true;
          setValidacion({...validacion, [name]: true});
          resp = false;
          //break;
        }
        if(data[name] instanceof Array && name=='preguntast'){
          let i=0;
          for(let elem of data[name]){
            for (var name2 in Object.assign({},initDataProveedorTransparenciaPreguntast_Val,Validate.limpiarObjeto(elem))) {
              //if (elem.hasOwnProperty(name2)){
                if(!elem[name2]){
                  if( i==0 || i==10
                  || (i>0 && i<7 && data[name][0].indRespuesta=='S') 
                  || ((i==7 || i==9) && !indEmpresa) 
                  || ((i==8 || i==9) && indEmpresa)){
                    console.log("LOGG"+(validacion[name]));
                    (validacion[name])[i] = (validacion[name])[i]?(validacion[name])[i]:{};
                    ((validacion[name])[i])[name2] = true;
                    setValidacion({...validacion, [name]: validacion[name]});
                    resp = false;
                  }
                }
              //}             
            }
            i++;
          }
        }
        if(data[name] instanceof Array && name=='listaCuadro' && data.preguntast[9].indRespuesta=='S'){
          let i=0;
          for(let elem of data[name]){
            for (var name2 in Object.assign({},initDataProveedorTransparencialistaCuadro_Val,Validate.limpiarObjeto(elem))) {
              //if (elem.hasOwnProperty(name2)){
                if(!elem[name2]){
                    if(name2=="aniosSentencia" && elem['idpEstado']!='SIN'){
                      console.log("LOGG"+(validacion[name]));
                      (validacion[name])[i] = (validacion[name])[i]?(validacion[name])[i]:{};
                      ((validacion[name])[i])[name2] = true;
                      setValidacion({...validacion, [name]: validacion[name]});
                      resp = false;
                    }               
                }
                if(name2=='aniosSentencia' && !Validate.validarLongitud(String(elem[name2]),4,4) && elem['idpEstado']!='SIN'){
                  (validacion[name])[i] = (validacion[name])[i]?(validacion[name])[i]:{};
                  ((validacion[name])[i])[name2] = true;
                  setValidacion({...validacion, [name]: validacion[name]});
                  resp = false;
                } 
              //}             
            }
            i++;
          }
        }
         
      //}     
    }
    return resp;
  }
  const resetAlert = () => {
    setShowAlert({
      show: false,
      title: "",
      message: "",
      type: "",
    });
  };
  
  const resetForm =() => {
    
  };

  const resetMessage = (sec) =>
    setTimeout(() => {
      resetAlert();
    }, sec * 1000);
 

  const handleCloseModal = (value) => {
    setOpenAdd(value);
  };

  const handleChangeEnvioCorreo = (event) => {
    console.log('============', event)
  };

  const handleChangeEmail = (text) => {
    console.log('============', text);
    };


  const handleOpenAddModal = (tag) => {    
    setTagBody(tag);
    resetForm();
    setOpenAdd(true);
  };

  const handleShowModal = (tag) => {
    setTagBody(tag);
    setInfoModal(true);
  };

  const fillEditForm = (row)=> {
    console.log(row);
      
  };
  
  const handleCloseAddModal = () => {
    setOpenAdd(false);
  };

  const bodyModal = (tag) => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10">{tag=='PEP'?'PEP (Persona Expuesta Politicamente)':'Informacion'}</h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          <h4 className="title-05 margin-bottom-10">
            {tag=='PEP'?`Personas naturales, nacionales o extranjeras, que cumplen o que en los 
             últimos cinco (5) años hayan cumplido funciones públicas destacadas o funciones prominentes
              en una organizacion internacional, sea en el territorio nacional o extranjero. Asimismo, 
              en caso sea el colaborador directo de la máxima autoridad de la institución. Ejemplo: 
              Congresistas, Ministros, Alcaldes, etc.`:''}
            
          </h4>
        </div>
      </div>
    );
  };    

  const handleSearchEndpoint = async () => {
    let payload = {
     
      
      
    };
    const fetchObj = {
      payload: payload,
    };
    dispatch(showLoading());
    const response = await callService(
      "POST",
      CONSTANTES.APIS_PATH.searchArea,
      fetchObj
    );
    dispatch(hideLoading());
    if (response.ok && response.data) {
      let { totalPages } = response.data;
      setPaginationData({ ...paginationData, totalPages: totalPages });

      let arrData =
        response &&
        response.data &&
        response.data.rows &&
        response.data.rows.map((item) => {
          let obj = {
            id: item.ID,
            dateTimeCreation: item.dateTimeCreation,
            name: item.name,
            email: item.email,
            emailRecepcion: item.emailRecepcion,
            estado: item.estado,
            sendMailValidation:  item.sendMailValidation? item.sendMailValidation: false,
            valEmailRecepcion:  item.valEmailRecepcion? item.valEmailRecepcion: false  
          };
          return obj;
        });
    } else {
      console.log("Error fetching data => ", response.message);
      
    }
  };
  let TABLE_COLUMNS = [
    { ResOrder: 1, 
      Title: "Nom. y Apell./Denom. Social",
      Special: (elem) => {
        return elem.nombres
      }  
    },
    {
      ResOrder: 2,
      Title: "                Estatus                ",
      Special: (elem, index) => {
        return (
          <div
            className="d-align-center pointer"
            style={{display: "block"}}
            //onClick={() => handleShowModal(elem, "comentario")}
          >
            <Select
              label=""
              selected={elem && arrTipoEstado.find(obj=>obj.value==elem.idpEstado)}
              onChange={(newValue) => { data.listaCuadro[index].idpEstado = newValue.value;
                                        handleChange("listaCuadro", data.listaCuadro, index);
                                      }}
              items={arrTipoEstado}
              hasError= {validacion.listaCuadro[index] && validacion.listaCuadro[index].idpEstado && '*'}
            />                   
          </div>        
        );       
      },
    },
    { ResOrder: 3, Title: "Año (AAAA)", 
      Special: (elem, index) => {
        return (
          <div className="d-align-center pointer"
                style={{display: "block"}}>
              <Input
                label=""
                name="aniosSentencia"
                maxLength="4"
                minLength="4"
                value={elem?.aniosSentencia}
                onChange={(newValue) => { data.listaCuadro[index].aniosSentencia = Number(newValue);
                          handleChange("listaCuadro", data.listaCuadro, index);
                        }
                }
                customRegex={/^[0-9]*$/}
                hasError= {(validacion.listaCuadro[index]  && validacion.listaCuadro[index].aniosSentencia) && '*'}                       
              />
          </div>
        )        
        } 
    },
    { ResOrder: 4, Title: "                  Tipo                  ", 
      Special: (elem, index) => {
        return (
          <div className="d-align-center pointer title-07"
                style={{display: "block"}}>
              { elem && arrTipoTercero.length>0 && elem.idpTipoTercero && arrTipoTercero.find(obj=>obj.value==elem.idpTipoTercero).text}
          </div>
        )        
        } 
    }    
  ];

  return (
    <div className="step__content" data-key={keyIndex}>
      <div className="proveedores_content">          
          <h4 className="title-05 margin-bottom-16 margin-top-16">
            <b>Registrar <span class="title-red">Información Complementaria:</span></b>
          </h4>
          {data.preguntast && data.preguntast.map((obj, index)=> {
            let label = arrPreguntat.find(el=>el.value==obj.idpPregunta)?.text; 
            if(Number(obj.idpPregunta)==9 && indEmpresa){
              label = label && label.replace('${nomRepresentante}',dataT.representante[0] && dataT.representante[0].nombres)
                      .replace('${tipDocRepresentante}',dataT.representante[0] && dataT.representante[0].idpTipoDocumento)
                      .replace('${numDocRepresentante}',dataT.representante[0] && dataT.representante[0].numeroDocumento)
                      .replace('${razonSocial}',dataT.nombreRazonSocial)
                      .replace('${numDocumento}',dataT.numDocumento)
            }       
            return (<>
            {(Number(obj.idpPregunta)==1 
              || ((Number(obj.idpPregunta)>1 && Number(obj.idpPregunta<=7)) && data.preguntast[0].indRespuesta=='S') 
              || ((Number(obj.idpPregunta)==8  && !indEmpresa))
              || ((Number(obj.idpPregunta)==9  && indEmpresa))
              || ((Number(obj.idpPregunta)==10))
              /*|| ((Number(obj.idpPregunta)==11))*/) &&
            (<> 
            {(Number(obj.idpPregunta)==8 || Number(obj.idpPregunta)==9) && <div className="documents_criteria_datos"><br/><b>2. Antecedentes Penales</b></div>}
            {Number(obj.idpPregunta)==10 && <div className="documents_criteria_datos"><br/><b>3. Temas de Investigación</b></div>}
            {/*Number(obj.idpPregunta)==11 && <div className="documents_criteria_datos"><br/><b>4. Datos Personales</b></div>*/}
            <div className="d-justify-space-between d-flex-column-m w100 text-justify">                 
              <div className="documents_criteria_datos">
                <label htmlFor="idpPregunta">
                {(Number(obj.idpPregunta)==1)?(<b>{label}</b>):(label)}
                </label>
              </div>                             
            </div>
            <div className="d-justify-space-between d-flex-column-m w100">
              <div className="documents_criteria_datos">               
                    <Radio
                        id={"indRespuestat"+index}
                        name={"indRespuestat"+index}
                        value="S"
                        onChange={(newValue) => { data.preguntast[index].indRespuesta = newValue;
                                                  handleChange("preguntast", data.preguntast, index);
                                                }}
                        isChecked={obj?.indRespuesta}
                        hasError= {validacion.preguntast[index] && validacion.preguntast[index].indRespuesta && '*'} 
                    >
                        Si
                    </Radio>
                    <Radio
                        id={"indRespuestat"+index}
                        name={"indRespuestat"+index}
                        value="N"
                        onChange={(newValue) => { data.preguntast[index].indRespuesta = newValue;
                                                  handleChange("preguntast", data.preguntast, index);
                                                }} 
                        isChecked={obj?.indRespuesta}
                        hasError= {validacion.preguntast[index] && validacion.preguntast[index].indRespuesta && '*'} 
                    >
                        No
                    </Radio>                    
              </div>
            </div>
            <br/>
            { Number(obj.idpPregunta)==10 && data.preguntast && data.preguntast[9] && data.preguntast[9].indRespuesta=='S' &&     
              <div className="documents_table_wrapp text-justify margin-bottom-10">
                <TableRimac
                  //TC_setGlobalCheked={handleGlobalChecked}
                  //TC_globalCheked={globalChecked}
                  TC_tableColumns={TABLE_COLUMNS}
                  TC_list={tableData}
                  //TC_handleChangeCheckBox={handleChangeCheckBox}
                  TC_hasIndex={false}
                  TC_hasPages={false}
                  TC_hasCheckbox={false}
                  TC_handleOrderData={(newList) => setTableData(newList)}
                />
              </div>
            }            
            </>
            )            
            }            
            </>
            );
          }
          )
          } 
          
          {/*<h4 className="title-05 margin-bottom-16 margin-top-16">
              Apliquemos Transparencia
          </h4>
          <div className="d-justify-space-between d-flex-column-m w100 text-justify margin-bottom-10">
            <div className="documents_criteria_datos">
              <label htmlFor="indAccionista2">
                ¿Se encuentran sentenciados o investigados?
              </label>
            </div>
          </div>
          <div className="d-flex-center w100">
              <div className="documents_criteria_link">
                <Button
                    size="small"
                    iconLeft={
                      <img
                        src={indVmTra?chevrotIconUp:chevrotIconDown}
                        alt="ver mas logo"
                        height={12}
                        className="bg-blue margin-left-6 margin-right-8"
                      />
                    }
                    onClick={() => setIndVmTra(!indVmTra)}
                    text={"Ver mas"}
                  >                      
                </Button> 
              </div>                
          </div>
          {indVmTra && 
          <div className="d-justify-space-between d-flex-column-m w100 text-justify margin-bottom-10">
            <div className="documents_criteria_datos">
                <label htmlFor="indAccionista2">
                  Marcar SI en caso alguna de las personas o empresas antes indicadas (accionistas, directores, gerentes o vinculados)
                  han sido sentenciadas o se encuentran investigadas por alguno de los siguientes delitos: tráfico ilícito de drogas
                  , terrorismo, mineria ilegal, delitos contra la administracion pública (corrupcion de funcionarios y enriquecimiento ilícito),
                  defraudacion tributaria, delitos contra el orden financiero y tributario, defraudacion de rentas de aduana, contrabando, estafa, 
                  fraude, proxenetismo, delitos contra el patrimonio, trata de personas, otros.
                </label>
            </div>
          </div>
          }           
          <br/>            
          <div className="documents_table_wrapp text-justify margin-bottom-10">
            <TableRimac
              //TC_setGlobalCheked={handleGlobalChecked}
              //TC_globalCheked={globalChecked}
              TC_tableColumns={TABLE_COLUMNS}
              TC_list={tableData}
              //TC_handleChangeCheckBox={handleChangeCheckBox}
              TC_hasIndex={false}
              TC_hasPages={false}
              TC_hasCheckbox={false}
              TC_handleOrderData={(newList) => setTableData(newList)}
            />
          </div>
          */}                            
          <div className="d-justify-space-between d-flex-column-m w100">
            <div className="documents_criteria_btns d-flex-end margin-bottom-16">
              <div className="documents_btnSearch">
                <Button
                  // type="submit"
                  primary
                  size="large"
                  onClick={()=>{
                    if(validarFormulario())
                        { let terceroProveedor = data.listaCuadro.find(e=>e.idpTipoTercero=="PRV");
                          handleActualizarFicha(Object.assign({}, {idpEstadoInvestigacion: terceroProveedor.idpEstado, aniosSentencia: terceroProveedor.aniosSentencia || ""}, data));
                          handleChangePaso(keyIndex);
                        }
                  }}
                >
                  Continuar
                </Button>
              </div>                  
            </div>
          </div>

      </div>
      <div className="proveedores_margen">
        <DatosProveedor data={dataT}/>       
      </div>
      <Modal
          className="rd--modal-info-files"
          onToggle={(value) => setInfoModal(false)}
          visible={infoModal}
          width={672}
          fullScreenMobile
          redHoverClosed
          onLabelClosed
          max12Padding
          footer={
            <Button primary onClick={() => setInfoModal(false)}>
              Cerrar
            </Button>
          }
        >
          {bodyModal(tagBody)}
      </Modal>            
    </div>
  );
};


export default ProveedoresTransparencia;
